export enum PROFILE_FIELD_NAMES {
  NAME = "name",
  DOB = "dob",
  EMPLOYMENT_TYPE = "employmentType",
  SALARY_MODE = "salaryMode",
  NET_MONTHLY_INCOME = "netMonthlyIncome",
  CURRENT_EMPLOYER = "currentEmployer",
  WORK_CIN = "workCin",
  MOBILE = "mobile",
  ADDRESS_PINCODE = "addressPincode",
  WORK_EXPERIENCE_MONTHS = "workExperienceMonths",
  HOUSE = "house",
  STREET = "street",
  LOCALITY = "locality",
  LANDMARK = "landmark",
  PINCODE = "pincode",
  EMPLOYER_TYPE = "employerType",
  RES_TENURE = "resTenure",
  REFERENCE_NAME = "referenceName",
  REFERENCE_MOBILE = "referenceMobile",
  RESIDENT_TYPE = "residentType",
  AADHAAR = "aadhar",
  CAPTCHA = "captcha",
  AMOUNT = "amount",
  PURPOSE = "purpose",
  TENURE = "tenure",
  ACCOUNT_NUMBER = "accountNumber",
  IFSC = "ifsc",
  BENEFICIARY_NAME = "beneficiaryName",
  PURPOSE_TYPE = "purposeType",
  EMPLOYEE_ID = "employeeId",
  TOTAL_DEPENDENTS = "numDependents",
  REFERENCES = "references",
  DESIGNATION = "designation",
  PAN = "panNumber",
  MOTHER_NAME = "mothersName",
  FATHER_OR_SPOUSE_NAME = "fatherOrSpouseName",
  GENDER = "gender",
  RELATIONSHIP_STATUS = "relationshipStatus",
  EDUCATION = "education",
  WORKING_SINCE = "duration",
  LIVING_WITH = "livingWith",
  ALTERNATE_ADDRESSES = "alternateAddresses",
  FINANCE_BASIC_INFO = "financeBasicInfo",
  INTEREST_ONLY_PERIOD = "interestOnlyPeriod",
  PAYMENT_FREQUENCY = "paymentFrequency",
  BUSINESS_SIZE = "businessSize",
  BUSINESS_SECTOR = "businessSector",
  INDUSTRY = "industry",
  FSSAI_LICENSE_NUMBER = "fssaiLicenseNumber",
  PERSON_WITH_DISABILITY = "personWithDisability",
}

export enum SALARY_MODE {
  BANK_TRANSFER = "BANK_TRANSFER",
  CHEQUE = "CHEQUE",
  CASH = "CASH",
}

export enum EMPLOYMENT_TYPE {
  SALARIED = "SALARIED",
  SELF_EMPLOYED = "SELF_EMPLOYED",
}

export enum PURPOSE_TYPE {
  NACH = "NACH",
  DISBURSAL = "DISBURSAL",
}

export enum LOCAL_STORAGE_ITEM {
  RATING_APPLICATION = "rating-application",
  RATING_LOANS = "rating-loans",
  USER = "user",
}
